import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import useSettlementManagementQuery from "@/features/my-order/features/settlement-management/hooks/useSettlementManagementQuery";
import { useSetRecoilState } from "recoil";
import settlementManagementCreditLoadingScope from "@/features/my-order/features/settlement-management/stores/useSettlementManagementCreditLoadingScope";
import { CreditInvoiceStatisticsByBoutique } from "@/features/my-order/features/settlement-management/types";

interface SettlementManagementCreditSupplierSelectSectionProps {
  boutiqueList: CreditInvoiceStatisticsByBoutique[];
  selectedBoutiqueId?: number;
}

function SettlementManagementCreditSupplierSelectSection({
  boutiqueList,
  selectedBoutiqueId,
}: SettlementManagementCreditSupplierSelectSectionProps) {
  const { tTitle, tCurrencyString, isKor } = useI18nHelper();
  const { setQuery } = useSettlementManagementQuery();
  const setLoadingScope = useSetRecoilState(
    settlementManagementCreditLoadingScope
  );

  const totalCredit = boutiqueList.reduce(
    (acc, curr) => acc + curr.totalAmount,
    0
  );

  return (
    <>
      <Flex justifyContent={"space-between"} padding={"20px 16px 0 16px"}>
        <Text textStyle={"heading-sm"} color={"#444444"}>
          {tTitle("current_balance")}
        </Text>
        <Text textStyle={"body-lg-bold"} color={"#1272EF"}>
          {isKor ? "총" : ""} {tCurrencyString(totalCredit)}
        </Text>
      </Flex>
      <Flex
        flexDirection={"column"}
        gap={"2px"}
        overflow={"auto"}
        padding={"16px"}
        paddingTop={"0px"}
      >
        {boutiqueList.map((item) => {
          const isSelected = selectedBoutiqueId === item.boutiqueId;

          return (
            <Flex
              key={item.boutiqueId}
              padding={"16px"}
              borderRadius={"8px"}
              justifyContent={"space-between"}
              background={isSelected ? "#EFEFED" : ""}
              _hover={{
                background: "#F7F9FA",
              }}
              _active={{
                background: "#EFEFED",
              }}
              onClick={() => {
                setLoadingScope("RIGHT PANEL");
                setQuery((prev) => ({
                  ...prev,
                  "issuedByCompany.id__eq": item.boutiqueId,
                }));
              }}
              cursor={"pointer"}
            >
              <Text textStyle={"body-lg-semi-bold"} color={"#363636"}>
                {item.boutiqueName}
              </Text>
              <Text textStyle={"body-lg-bold"} color={"#363636"}>
                {tCurrencyString(item.totalAmount)}
              </Text>
            </Flex>
          );
        })}
      </Flex>
    </>
  );
}

export default SettlementManagementCreditSupplierSelectSection;
